import { css } from 'styled-components';
import { MessagePageProps } from './models';

export const MessagePage = css<MessagePageProps>(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `;
});
